import { Node } from 'prosemirror-model'
import { ProsePreview } from 'common/ProsePreview/ProsePreview'
import { schema } from 'prose-core'
import { EditorView } from 'prosemirror-view'
import { useReactNodeViewPortals } from 'common/Prose/nodeViews/ReactNodeView/ReactnodeViewPortalsContext'
import { ImagePreview } from 'common/Prose/nodeViews/Image/Image'
import { reactNodeViewFactory } from 'common/Prose/nodeViews/utils/reactNodeViewFactory'
import { ReactNodeViewPortalsProvider } from 'common/Prose/nodeViews/ReactNodeView/ReactNodeViewPortals'

interface Props {
  contentData: string
  view: EditorView
  className?: string
}

const PreviewContentData = ({ contentData, view, className }: Props) => {
  const wrappedNode = Node.fromJSON(view.state.schema, { type: 'doc', content: JSON.parse(contentData) })
  const { createPortal, removePortal } = useReactNodeViewPortals()
  const makeReactNodeViewFn = reactNodeViewFactory(createPortal, removePortal, false)

  return (
    <ProsePreview
      nodes={wrappedNode.content}
      schema={schema}
      className={className}
      nodeViews={{
        image: makeReactNodeViewFn(ImagePreview),
      }}
    />
  )
}

const PreviewContentDataContainer = (props: Props) => (
  <ReactNodeViewPortalsProvider>
    <PreviewContentData {...props} />
  </ReactNodeViewPortalsProvider>
)

export { PreviewContentDataContainer as PreviewContentData }
